module.exports = __webpack_public_path__ + "img/Icon-Resource-Center.05652319.svg";